module.exports = __webpack_public_path__ + "img/logo3.1ae19c13.jpg";